import { DateRangeDropdown } from './DateRangeDropdown';
import { GenericFilter } from '../GenericBloc/GenericFilter/GenericFilter';
import type { DateRange, MinimalDateConstraint } from './DateRangeFilterType';
import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { DateRangeToggleGroup } from './DateRangeToggleGroup';
import { CustomDateRangeDropdown } from './CustomDateRangeDropdown';
import { getDateRangeLabel } from './DateRangeFilterFormatter';

const FILTER_NAME = 'Date range';

interface DateRangeFilterProps extends AbstractSingleFilterPillsProps<DateRange> {
  hideAllDatesOption?: boolean;
  dateConstraint?: MinimalDateConstraint;
  optionalAllDatesLabel?: string;
  useToggleGroupDatePicker?: boolean;
}

export function DateRangeFilter({
  currentValue,
  autoFocus,
  optionalDefaultValue,
  onApply,
  hideAllDatesOption,
  dateConstraint,
  onDropdownHidden,
  showDropdownOnMount,
  isInactive,
  onRemove,
  optionalAllDatesLabel,
  useToggleGroupDatePicker,
}: DateRangeFilterProps): JSX.Element {
  const handleApply = (newValue?: DateRange, close?: () => void) => {
    onApply(newValue);
    close?.();
  };

  const isAutoSelected = currentValue?.autoSelectedConstraint != null;

  if (useToggleGroupDatePicker === true) {
    return (
      <DateRangeToggleGroup
        filterName={FILTER_NAME}
        currentValue={currentValue}
        optionalDefaultValue={optionalDefaultValue}
        onApply={(newValue) => handleApply(newValue)}
        hideAllDatesOption={hideAllDatesOption}
        dateConstraint={dateConstraint}
        isAutoSelected={isAutoSelected}
        renderDropdown={({ close }) => {
          return (
            <CustomDateRangeDropdown
              filterName={FILTER_NAME}
              currentValue={currentValue}
              optionalDefaultValue={optionalDefaultValue}
              onApply={(newValue) => handleApply(newValue, close)}
              dateConstraint={dateConstraint}
            />
          );
        }}
      />
    );
  }

  return (
    <GenericFilter
      filterName={FILTER_NAME}
      label2={getDateRangeLabel(currentValue, optionalAllDatesLabel)}
      autoFocus={autoFocus}
      iconName="date"
      showDropdownCaret
      onRemove={onRemove}
      isInactive={isInactive}
      isAutoSelected={isAutoSelected}
      showDropdownOnMount={showDropdownOnMount}
      onDropdownHidden={onDropdownHidden}
      renderDropdown={({ close }) => {
        return (
          <DateRangeDropdown
            filterName={FILTER_NAME}
            currentValue={currentValue}
            optionalDefaultValue={optionalDefaultValue}
            onApply={(newValue) => handleApply(newValue, close)}
            hideAllDatesOption={hideAllDatesOption}
            dateConstraint={dateConstraint}
          />
        );
      }}
    />
  );
}
